<form [formGroup]="form">
  <div class="card-inline">
    <h3 class="card-inline">Orden</h3>

    <app-transaction-reference
      *ngIf="existsMedicalAppointmentValidation && !validating"
      [transactionReferenceNumber]="transactionReferenceNumber"
      [transactionReferenceMessage]="transactionReferenceMessage"
      [medicalAppointmentId]="medicalAppointmentId"
      [enabledEdition]="enabledEdition"
    >
    </app-transaction-reference>


    <div *ngIf="validateOnLineNeedCancel && !validating && !isReadOnly" class="card-inline">
      <button
        *ngIf="!isDisabled && validateOnLineNeedCancel"
        type="button"
        class="margin-left-small"
        matTooltip="Anular"
        (click)="executeOnLineCancelOperation()"
        type="button"
        mat-mini-fab
      >
        <mat-icon>cloud_off</mat-icon>
      </button>
    </div>
    <mat-spinner
      *ngIf="validateOnLineNeedCancel && validating"
      [diameter]="20"
    ></mat-spinner>
  </div>
  <mat-divider></mat-divider>
  <div
    formGroupName="MedicalOrder"
    class="aling-top full-width margin-top-medium"
  >
    <div
      *ngIf="canViewReferringPhysician"
      class="card-inline referring-physician-autocomplete full-width"
    >
      <referring-physician-autocomplete
        [readOnly]="isReadOnly"
        #referringPhysician
        formControlName="ReferringPhysician"
      ></referring-physician-autocomplete>
    </div>
    <div
      *ngIf="referringPhysicianInstituteVisible"
      class="card-inline referring-physician-autocomplete full-width"
    >
      <app-referring-physician-institute
        #referringPhysicianInstitute
        formControlName="ReferringPhysicianInstitute"
      ></app-referring-physician-institute>
    </div>
    <mat-form-field class="card-inline margin-right-small">
      <mat-label>Número de afiliado</mat-label>
      <input
        type="text"
        matInput
        #credentialNumber
        formControlName="CredentialNumber"
      />
      <mat-error *ngIf="form.errors && form.errors.invalidCredentialNumber">
        Ingrese el número de afiliado
      </mat-error>
    </mat-form-field>
    <mat-form-field
      *ngIf="securityCodeValidate"
      class="card-inline margin-right-small"
    >
      <mat-label>Código de seguridad</mat-label>
      <input
        type="text"
        matInput
        formControlName="SecurityCodeCredentialNumber"
      />
    </mat-form-field>
    <mat-form-field
      *ngIf="preAuthorizationValidate"
      class="card-inline margin-right-small"
    >
      <mat-label>Nro pre autorización</mat-label>
      <input type="text" matInput formControlName="NroPreAuthorization" />
    </mat-form-field>
    <button
      type="button"
      *ngIf="
       !isReadOnly &&
        !disabledValidationOnLine &&
        !isDisabled &&
        validateOnLineVisible &&
        !validating
      "
      class="margin-right-small"
      matTooltip="Validar"
      (click)="executeOnLineOperation()"
      type="button"
      mat-mini-fab
    >
      <mat-icon>cloud_done</mat-icon>
    </button>
    <mat-spinner
      *ngIf="validateOnLineVisible && validating"
      [diameter]="20"
    ></mat-spinner>

    <mat-form-field
      *ngIf="canViewMedicaOrderDate"
      class="card-inline margin-right-small"
    >
      <input
        matInput
        formControlName="PrescriptionDate"
        #dateOrder
        [matDatepicker]="picker"
        placeholder="Fecha {{ validityDays }}"
      />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      <mat-error
        *ngIf="
          medicalOrder.PrescriptionDate.errors &&
          medicalOrder.PrescriptionDate.errors.required
        "
      >
        Ingrese la fecha de la orden
      </mat-error>
      <mat-error *ngIf="form.errors && form.errors.invalidAthorizationValidity">
        Fecha de la orden vencida
      </mat-error>
    </mat-form-field>

    <mat-form-field class="card-inline margin-right-small">
      <input
        type="text"
        matInput
        placeholder="Estado de la orden"
        formControlName="MedicalOrderState"
        [matAutocomplete]="autMedicalOrderState"
        required
      />
      <mat-autocomplete
        #autMedicalOrderState="matAutocomplete"
        [displayWith]="filterCompleteautMedicalOrderState.displayFn"
      >
        <mat-option
          *ngFor="let medicalOrderState of filteredOrderStatesOptions | async"
          [value]="medicalOrderState"
        >
          {{ medicalOrderState.Name }}
        </mat-option>
      </mat-autocomplete>
      <mat-error
        *ngIf="
          medicalOrder.MedicalOrderState.errors &&
          medicalOrder.MedicalOrderState.errors.validAutoCompleteSelect
        "
      >
        Ingrese el estado de la orden
      </mat-error>
    </mat-form-field>

    <mat-form-field
      class="card-inline margin-right-small"
      *ngIf="isPatientAmountVisible"
    >
      <mat-label>Paciente Abona $</mat-label>
      <input
        matInput
        type="number"
        formControlName="IncompleteMedicalOrderAmount"
      />
    </mat-form-field>
  </div>

  <p *ngIf="CIEDiagnosisVisible">
    <mat-form-field
      formGroupName="MedicalOrder"
      class="medium-width margin-right-small"
    >
      <input
        type="text"
        matInput
        placeholder="Diagnóstico C.I.E."
        formControlName="DiagnosisCIE"
        [matAutocomplete]="autDiagnosisCIE"
        required
      />
      <mat-autocomplete
        #autDiagnosisCIE="matAutocomplete"
        [displayWith]="filterCompleteautDiagnosisCIE.displayFn"
      >
        <mat-option
          *ngFor="let diagnosisCIE of filteredDiagnosesCIEOptions | async"
          [value]="diagnosisCIE"
        >
          {{ diagnosisCIE.Name }}
        </mat-option>
      </mat-autocomplete>
      <mat-error
        *ngIf="
          medicalOrder.DiagnosisCIE.errors &&
          medicalOrder.DiagnosisCIE.errors.isValidDiagnosisCIE
        "
      >
        Ingrese el diagnóstico C.I.E.
      </mat-error>
    </mat-form-field>
  </p>

  <p *ngIf="freeDiagnosisVisible">
    <mat-form-field
      formGroupName="MedicalOrder"
      class="medium-width margin-right-small"
    >
      <textarea
        maxlength="250"
        matInput
        placeholder="Diagnóstico"
        formControlName="Diagnostic"
      ></textarea>
      <mat-error *ngIf="form.errors && form.errors.invalidDiagnostic">
        Ingrese el diagnóstico
      </mat-error>
    </mat-form-field>
  </p>
  <p>
    <mat-form-field class="medium-width margin-right-small">
      <mat-label>Observaciones internas</mat-label>
      <textarea
        maxlength="250"
        matInput
        formControlName="OrderObservation"
      ></textarea>
      <button *ngIf="!isReadOnly && !isDisabled" matSuffix mat-mini-fab>
        <mat-icon>edit</mat-icon>
      </button>
    </mat-form-field>
  </p>
  <p>
    <mat-form-field class="medium-width margin-right-small">
      <mat-label>Observaciones paciente</mat-label>
      <textarea
        maxlength="250"
        matInput
        formControlName="PatientObservation"
      ></textarea>
      <button *ngIf="!isReadOnly && !isDisabled " matSuffix mat-mini-fab>
        <mat-icon>edit</mat-icon>
      </button>
    </mat-form-field>
  </p>
</form>
